/* ================================================================
 * Copyright © 2025 Tobeunicorn Co., Ltd. All rights reserved.
 *
 * 프로젝트명 : ArmyLink V1.0
 * 설명 : 홍보 결과 목록 > 관심표명자 다이얼로그
 * 버전 : 1.0
 * 파일명 : PromoResultInterestDialog.tsx
 * 작성자 : 강동형
 * 작성일 : 2025-03-01
 * ================================================================ 
 * 수정 : 2025-07-17, 강동형 : 저작권 추가, 필터 바 추가
 *================================================================
 */

import React, { useEffect } from 'react'
import { Dialog, SlideProps, Slide } from '@mui/material';
import { usePromoDialogInterest } from 'src/stores/PromoStore';

// 모달창 슬라이드 트랜지션 스타일
const Transition = React.forwardRef(function Transition(
props: SlideProps,
ref: React.Ref<unknown>
) {
return <Slide direction="up" ref={ref} {...props} timeout={500} />;
});

//로직 영역
const PromoResultInterestDialog = () => {
  const isOpen = usePromoDialogInterest((state)=>state.isOpen)
  const setField = usePromoDialogInterest((state)=>state.setField)
  const reset = usePromoDialogInterest((state)=>state.reset)
  const element = usePromoDialogInterest((state)=>state.element)

  useEffect(()=>{
    return()=>{
      reset()
    }
  },[])

  return (
    <Dialog
        open={isOpen}
        onClose={()=>setField('isOpen',false)}
        fullWidth
        TransitionComponent={Transition}
        PaperProps={{
          sx: {
            position: 'fixed',
            bottom: 0,
            margin: 0,
            width: '100vw',
            height: 'auto',
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
          }
        }}
      >
        {element}
      </Dialog>
  )
}

export default PromoResultInterestDialog